import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import defaults from './defaultContent.json';
import { validateConfig } from './helpCore';

const HelpContext = createContext(null);
export const useHelp = () => useContext(HelpContext);
export function HelpProvider({ children }) {
  const account = useSelector((s) => s.user.userDetails?.localAccountId);
  const environment = useSelector((s) => s.environment?.environment || 'default');
  const key = `portal-help:v1:${environment}:${account || 'anonymous'}`;
  const [draft, setDraft] = useState(null);
  useEffect(() => {
    try {
      const raw = localStorage.getItem(key);
      setDraft({ key, config: raw ? validateConfig(JSON.parse(raw)) : defaults });
    } catch {
      setDraft({ key, config: defaults, warning: 'The saved help draft could not be read. Using bundled defaults.' });
    }
  }, [key]);
  const value = useMemo(() => ({
    config: draft?.key === key ? draft.config : defaults,
    warning: draft?.key === key ? draft.warning : '',
    save(config) {
      validateConfig(config);
      localStorage.setItem(key, JSON.stringify(config)); // Report quota/security failures to the editor.
      setDraft({ key, config });
    },
    reset() {
      localStorage.removeItem(key);
      setDraft({ key, config: defaults });
    },
  }), [draft, key]);
  return <HelpContext.Provider value={value}>{children}</HelpContext.Provider>;
}
